import { EyeInvisibleOutlined, EyeTwoTone, PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal } from 'antd';
import isFunction from 'lodash/isFunction';
import React, { useEffect } from 'react';

import ServicesSelect from '@Modules/PurchasingManager/components/ServicesSelect';
import useAddPurchasingAccountMutation from '@Modules/Setting/Hooks/useAddPurchasingAccountMutation';

import { t } from '@System/i18n';

const validatedRules = {
    purchasing_service_id: [
        {
            required: true,
            message: t('validation:required', {
                attribute: t('label.service'),
            }),
        },
    ],
    username: [
        {
            required: true,
            whitespace: true,
            message: t('validation:required', {
                attribute: t('label.username'),
            }),
        },
        {
            max: 255,
            message: t('validation:max.string', {
                attribute: t('label.username'),
                max: 255,
            }),
        },
    ],
    password: [
        {
            required: true,
            whitespace: true,
            message: t('validation:required', {
                attribute: t('label.password'),
            }),
        },
        {
            max: 255,
            message: t('validation:max.string', {
                attribute: t('label.password'),
                max: 255,
            }),
        },
    ],
};

const AddPurchasingAccountModal = ({ visible, onCancel, onOk }) => {
    const [form] = Form.useForm();
    const { isLoading: adding, mutate: addPurchasingAccount } = useAddPurchasingAccountMutation({
        onSuccess: () => {
            if (isFunction(onOk)) {
                onOk();
            }
        },
    });

    const handleOk = () => {
        form.submit();
    };

    const handleFinish = (values) => {
        addPurchasingAccount(values);
    };

    useEffect(() => {
        if (!visible) {
            form.resetFields();
        }
    }, [visible]);

    return (
        <Modal
            className="_add-purchasing-account-modal"
            footer={
                <>
                    <Button className="_cancel-btn" onClick={onCancel}>
                        {t('btn.close')}
                    </Button>
                    <Button className="_ok-btn" type="primary" loading={adding} onClick={handleOk}>
                        <PlusOutlined />
                        {t('btn.add_account')}
                    </Button>
                </>
            }
            title={t('btn.add_account')}
            visible={visible}
            onCancel={onCancel}
        >
            <Form form={form} layout="vertical" onFinish={handleFinish}>
                <Form.Item label={t('label.service')} name="purchasing_service_id" rules={validatedRules.purchasing_service_id}>
                    <ServicesSelect
                        className="_services"
                        dropdownClassName="_services-dropdown"
                        placeholder={t('placeholder.select_service_need_to_link')}
                    />
                </Form.Item>

                <Form.Item label={t('label.username')} name="username" rules={validatedRules.username}>
                    <Input className="_username" placeholder={t('placeholder.username')} />
                </Form.Item>

                <Form.Item label={t('label.password')} name="password" rules={validatedRules.password}>
                    <Input.Password
                        autoComplete="new-password"
                        className="_password"
                        iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                        placeholder={t('placeholder.password')}
                    />
                </Form.Item>

                <Form.Item label={t('label.pin_code')} name="pin_code">
                    <Input.Password className="_pin-code" placeholder={t('placeholder.pin_code')} />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default AddPurchasingAccountModal;
